import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import {map} from 'rxjs/operators';
import {UserService} from '../../user/user.service';
import {catchError, Observable, of, take, timeout} from 'rxjs';
import {User} from '@models/user.interface';
import {AccountRole} from '@enums/AccountRole';

@Injectable({
    providedIn: 'root'
})
export class RoleGuard  {
    constructor(private readonly _userService: UserService, private readonly _router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        const allowedRoles = route.data['allowedRoles'] as AccountRole[];
        return this._userService.get().pipe(
            take(1),
            map((user: User): boolean => {
                if (!user) {
                    void this._router.navigate(['/sign-in']);
                    return false;
                }

                const isUserAllowed = allowedRoles.includes(user.rol);
                if (!isUserAllowed) {
                    void this._router.navigate(['/404-not-found']);
                    console.warn('User is not allowed to access this route.');
                    return false;
                }

                return true;
            }),
            timeout(5000),
            catchError((e) => {
                console.error(e);
                void this._router.navigate(['/404-not-found']);
                return of(false);
            })
        );
    }
}
